import React, { useEffect } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import VerticalCard from '../Components/VerticalCard';
import CommunitiesList from '../Components/CommunitiesList';
import Loader from '../../common/Loader';

import WithLazyLoad from '../../../hocs/withLazyLoad';
import { COMMUNITIES } from '../../../constants/routes';
import { COMMUNITIES_COMMON } from '../../../constants/strings';
import {
  COMMUNITY_BTN_ACTIONS,
  DISCOVERY_LIST_TYPES,
} from '../../../constants';
import { useInjectSaga } from '../../../redux/injectSaga';
import { RESTART_ON_REMOUNT } from '../../../redux/sagaInjectors';
import updateCurrentCommunity from '../../../redux/communities/sagas/updateCurrentCommunity';
import getButtonInfo from '../../../utils/communities/getButtonInfo';

import { enhance } from './enhance';

const OrganizationCommunities = ({
  getAllCommunities,
  organizationCommunitiesCount,
  organizationCommunitiesList,
  sendingDiscoverCommunities,
  loadNextCommunities,
  reqJoinCommunity,
  intl: { formatMessage },
  acceptInvite,
}) => {
  useInjectSaga({
    key: 'updateCurrentCommunity',
    saga: updateCurrentCommunity,
    mode: RESTART_ON_REMOUNT,
  });

  useEffect(() => {
    getAllCommunities({ type: DISCOVERY_LIST_TYPES.ORGANIZATION, limit: 12 });
  }, []);

  const loadMore = () => {
    loadNextCommunities({ type: DISCOVERY_LIST_TYPES.ORGANIZATION });
  };

  const handleSelect = community => {
    const route = `/${COMMUNITIES}/${community.id}`;
    browserHistory.push(route);
  };

  const handleJoinCommunity = ({ id, memberInvitationId }, actionType) => {
    if (actionType === COMMUNITY_BTN_ACTIONS.ACCEPT) {
      acceptInvite({
        id: memberInvitationId,
        actionType: COMMUNITY_BTN_ACTIONS.ACCEPT,
      });
      return;
    }
    reqJoinCommunity({ communityId: id });
  };

  return (
    <WithLazyLoad loadMore={loadMore}>
      <div styleName="wrapper">
        <CommunitiesList
          title={formatMessage(COMMUNITIES_COMMON.fromOrganization)}
          counter={organizationCommunitiesCount}
        >
          {organizationCommunitiesList.map(community => {
            const buttonInfo = getButtonInfo(community, formatMessage);

            return (
              <VerticalCard
                key={community.id}
                banner={get(community, 'banner.url')}
                logo={get(community, 'logo.url')}
                name={community.name}
                organization={get(community, 'organization.name')}
                totalPosts={community.totalPosts}
                totalUsers={community.totalUsers}
                onClick={() => handleSelect(community)}
                joinCommunity={() =>
                  handleJoinCommunity(community, buttonInfo.type)
                }
                buttonInfo={buttonInfo}
              />
            );
          })}
        </CommunitiesList>
        <If condition={sendingDiscoverCommunities}>
          <Loader />
        </If>
      </div>
    </WithLazyLoad>
  );
};

OrganizationCommunities.propTypes = {
  getAllCommunities: PropTypes.func.isRequired,
  loadNextCommunities: PropTypes.func.isRequired,
  reqJoinCommunity: PropTypes.func.isRequired,
  acceptInvite: PropTypes.func.isRequired,
  organizationCommunitiesList: PropTypes.arrayOf(PropTypes.object),
  sendingDiscoverCommunities: PropTypes.bool.isRequired,
  organizationCommunitiesCount: PropTypes.number.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

OrganizationCommunities.defaultProps = {
  organizationCommunitiesList: [],
};

export default enhance(OrganizationCommunities);



// WEBPACK FOOTER //
// ./src/components/Communities/OrganizationCommunities/index.jsx